import React from 'react';
import { Attachment as AttachmentIcon } from '@mui/icons-material';
import CatalogoIdDescripcion, { CatalogoIdDescripcionForm } from './CatalogoIdDescripcion';

export { CatalogoIdDescripcionForm as CatalogoAnexosForm };

/**
 * Catálogo reutilizable de anexos (id, descripcion).
 * Diálogo (`open` / `onClose`) o embebido (`embedded`).
 */
const CatalogoAnexos = (props) => (
  <CatalogoIdDescripcion
    titulo="Anexos"
    singular="Anexo"
    icono={AttachmentIcon}
    listPath="/contabilidadbackend_listaranexofiscal"
    savePath="/contabilidadbackend_guardaranexofiscal"
    deletePath="/contabilidadbackend_eliminaranexofiscal"
    listKey="anexos"
    {...props}
  />
);

export default CatalogoAnexos;
